// extracted by mini-css-extract-plugin
export var scrollArea = "_oz-0";